import { CHANGE_PASSWORD } from "../services/apiUrls";
import { post } from "../services/service";

export const changePassword = async (formValues) => {
  let response = await post(CHANGE_PASSWORD, formValues);
  return response;
};
